var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container"},[_c('hotel-form',{attrs:{"dialog-data":_vm.responseDialog,"duplicated-dialog":_vm.duplicatedDialog},on:{"update:dialogData":function($event){_vm.responseDialog=$event},"update:dialog-data":function($event){_vm.responseDialog=$event},"finish":_vm.finish}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }